import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import AppContainer from './container';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();